module.exports = __webpack_public_path__ + "static/img/KJY_nav2.904eaba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/KJY_nav2.png
// module id = zh7P
// module chunks = 1